export default function TrackRecordSection() {
  const achievements = [
    {
      number: '12+',
      label: 'Properties Purchased',
      description: 'Successfully closed on over a dozen multi-family properties across Texas'
    },
    {
      number: '$85M+',
      label: 'Total Transaction Value',
      description: 'Over $85 million in apartment building purchases completed'
    },
    {
      number: '2,400+',
      label: 'Total Units Acquired',
      description: 'Purchased apartments ranging from 2 to 50 units per building'
    },
    {
      number: '100%',
      label: 'Title Company Closings',
      description: 'Every single transaction handled through reputable title companies'
    },
    {
      number: '12',
      label: 'Average Days to Close',
      description: 'Our average closing time from accepted offer to funded deal'
    },
    {
      number: '98%',
      label: 'Seller Satisfaction Rate',
      description: 'Nearly all sellers would recommend us to other property owners'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Our Track Record
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Proven Track Record of Successful Apartment Purchases
          </h2>
          <p className="text-xl text-teal-100 max-w-3xl mx-auto">
            When you need apartment buyers with a documented history of successful closings, look at our numbers. We have the experience, resources, and reputation to handle any size transaction.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {achievements.map((achievement, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 text-center hover:bg-white/20 transition-all duration-300"
            >
              <div className="text-5xl md:text-6xl font-bold text-white mb-3">{achievement.number}</div>
              <div className="text-xl font-bold text-white mb-3">{achievement.label}</div>
              <div className="text-teal-100">{achievement.description}</div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Why Our Track Record Matters</h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                When you're selling a valuable asset like an apartment building, you need to work with apartment buyers who have proven they can close deals. Our track record demonstrates our ability to evaluate properties accurately, make fair offers, secure financing, and complete transactions on time.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                We've purchased everything from small duplexes to 50-unit complexes. We've bought properties in pristine condition and buildings needing major renovations. We've handled simple transactions and complex deals involving multiple liens, tenant issues, and title problems.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-2xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Verified Closings:</strong> We can provide references from title companies and previous sellers</span>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-2xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Financial Strength:</strong> We have the cash reserves and credit lines to close on large deals</span>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-2xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Industry Reputation:</strong> A+ rated with the BBB and member of local real estate associations</span>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/e11bee025128ed0b3ec27d4f83620894.jpg"
                alt="Proven Track Record Apartment Buyers"
                className="rounded-2xl shadow-2xl w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}